<template>
  <layouts>
    <template #content>
      <div class="bg-gray-200 h-auto">
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-center justify-between mb-6">
            <div class="lg:w-1/2 w-full">
              <input
                v-model="search"
                @input="debouncedSearch($event.target.value)"
                type="text"
                class="border border-gray-400 px-3 py-2 text-sm rounded-md lg:w-1/2 w-full"
                placeholder="Pencarian.."
              />
            </div>
            <button
              @click="
                formDialog = !formDialog;
                dataSelected = [];
                emptyFormData();
              "
              class="ml-auto bg-green-600 hover:bg-green-700 rounded-md px-3 py-2 text-sm text-white focus:outline-none flex items-center transition duration-300 ease-in"
            >
              <svg
                class="w-3.5 h-3.5 mr-2 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style="transform:;-ms-filter:"
              >
                <path
                  d="M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10c5.514,0,10-4.486,10-10S17.514,2,12,2z M17,13h-4v4h-2v-4H7v-2h4V7h2v4h4V13z"
                ></path>
              </svg>
              <h4 class="font-semibold">Tambah</h4>
            </button>
          </div>
          <table-skeleton
            v-if="tableLoading"
            :columns="columns"
            :rows="listParams.limit > 10 ? 10 : listParams.limit"
          ></table-skeleton>
          <datatable
            v-else
            :data="data.data"
            :columns="columns"
            :meta="data.meta"
            :PageNavHandler="pageNavHandler"
            :TableInputSearchHandler="tableInputSearchHandler"
          >
            <!-- Custom Field -->
            <template slot="address" slot-scope="props">
              <h6 class="text-sm max-w-lg truncate">
                {{ props.item.address }}
              </h6>
            </template>
            <template slot="action" slot-scope="props">
              <div class="flex items-center">
                <button
                  @click="editBranch(props.item.id)"
                  class="bg-gray-200 hover:bg-gray-300 border border-gray-300 hover:border-gray-400 focus:border-gray-400 rounded-md px-3 py-1 text-sm text-gray-600 focus:outline-none flex items-center mr-2"
                  style="font-size: 11px"
                >
                  <svg
                    class="w-4 h-4 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style="transform:;-ms-filter:"
                  >
                    <path
                      d="M16,2H8C4.691,2,2,4.691,2,8v13c0,0.553,0.447,1,1,1h13c3.309,0,6-2.691,6-6V8C22,4.691,19.309,2,16,2z M8.999,17H7v-1.999 l5.53-5.522l1.999,1.999L8.999,17z M15.472,10.535l-1.999-1.999l1.524-1.523l1.999,1.999L15.472,10.535z"
                    ></path>
                  </svg>
                  <h4 class="font-semibold">Ubah</h4>
                </button>
                <button
                  @click="
                    dataSelected = props.item;
                    deleteConfirmModal = true;
                  "
                  class="bg-red-400 hover:bg-red-500 border border-red-500 hover:border-red-600 focus:border-red-600 rounded-md px-3 py-1 text-sm text-white focus:outline-none flex items-center"
                  style="font-size: 11px"
                >
                  <svg
                    class="w-4 h-4 mr-2 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style="transform:;-ms-filter:"
                  >
                    <path
                      d="M16,2H8C4.691,2,2,4.691,2,8v13c0,0.553,0.447,1,1,1h13c3.309,0,6-2.691,6-6V8C22,4.691,19.309,2,16,2z M16.706,15.293 l-1.414,1.414L12,13.415l-3.292,3.292l-1.414-1.414l3.292-3.292L7.294,8.709l1.414-1.414L12,10.587l3.292-3.292l1.414,1.414 l-3.292,3.292L16.706,15.293z"
                    ></path>
                  </svg>
                  <h4 class="font-semibold">Hapus</h4>
                </button>
              </div>
            </template>
            <!-- / End Custom Field -->
          </datatable>
        </div>
        <!-- Form Dialog -->
        <div
          v-show="formDialog"
          class="fixed inset-0 bg-gray-600 bg-opacity-80 transition-opacity"
          aria-hidden="true"
        ></div>
        <transition
          enter-active-class="transform transition ease-in-out duration-700 sm:duration-700"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transform transition ease-in-out duration-700 sm:duration-700"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
        >
          <addForm
            v-show="formDialog"
            @close="formDialog = false"
            :title="dataSelected.length === 0 ? 'Tambah Cabang' : 'Ubah Cabang'"
            @submit="handleSubmit"
          >
            <div class="space-y-4">
              <div>
                <label
                  id="listbox-label"
                  class="block text-sm leading-5 font-semibold text-gray-800 mb-1"
                >
                  Nama Kota/Lokasi
                </label>
                <input
                  v-model="city_name"
                  class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-2"
                  placeholder="contoh: Jakarta"
                  type="text"
                />
              </div>
              <div>
                <label
                  id="listbox-label"
                  class="block text-sm leading-5 font-semibold text-gray-800 mb-1"
                >
                  Alamat
                </label>
                <textarea
                  v-model="address"
                  rows="5"
                  class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-2"
                >
                </textarea>
              </div>
              <div>
                <label
                  id="listbox-label"
                  class="block text-sm leading-5 font-semibold text-gray-800 mb-1"
                >
                  Nomor Telpon
                </label>
                <input
                  v-model="phone"
                  class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-2"
                  placeholder="contoh: 0813-4543-5346"
                  type="text"
                />
              </div>
            </div>
          </addForm>
        </transition>
        <!-- Notification -->
        <transition
          enter-active-class="transform transition ease-in-out duration-700 sm:duration-700"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transform transition ease-in-out duration-700 sm:duration-700"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
        >
          <notification
            v-show="successNotification"
            :message="
              dataSelected.length === 0
                ? 'Berhasil! Cabang baru sudah ditambahkan!'
                : 'Berhasil! Cabang sudah diubah!'
            "
            @close="successNotification = false"
          ></notification>
        </transition>
        <!-- Delete Confirm Modal -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="opacity-100"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="deleteConfirmModal"
            class="fixed inset-0 transition-opacity"
            aria-hidden="true"
          >
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
        </transition>
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="opacity-100 translate-y-0 sm:scale-100"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <modal
            v-show="deleteConfirmModal"
            title="Hapus Data Cabang"
            message="Anda yakin ingin menghapus data cabang ini?<br/> Data akan dihapus secara permanen. Tindakan ini tidak bisa dibatalkan."
            @close="
              deleteConfirmModal = false;
              dataSelected = [];
            "
            @confirm="deleteBranch()"
          ></modal>
        </transition>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import datatable from "@/components/datatables/advance_table";
import tableSkeleton from "@/components/datatables/table_skeleton";
import addForm from "@/components/datatables/add_form";
import notification from "@/components/datatables/notification";
import modal from "@/components/datatables/modal";
import http from "@/config/http";
import { reactive, computed } from "@vue/composition-api";
import { useQueryClient } from "@tanstack/vue-query";
import { useBranchAdminList } from "@/composables/master/useMasterAdmin";
import { fetchBranchById } from "@/queries/api/masterAdmin";
import { keys } from "@/queries/keys";
import { useInvalidate } from "@/composables/useInvalidate";
export default {
  components: { layouts, datatable, tableSkeleton, addForm, notification, modal },
  setup() {
    /* Params reactive — query auto-refetch saat berubah */
    const listParams = reactive({
      page: 1,
      limit: 10,
      pagination: true,
      search: "",
    });
    const branchListQuery = useBranchAdminList(computed(() => ({ ...listParams })));
    const invalidate = useInvalidate();
    const qc = useQueryClient();
    return {
      listParams,
      branchListData: branchListQuery.data,
      branchListLoading: branchListQuery.isLoading,
      branchListIsFetching: branchListQuery.isFetching,
      branchListRefetch: branchListQuery.refetch,
      invalidate,
      qc,
    };
  },
  data() {
    return {
      /* Auth Token */
      /* Data List */
      dataSelected: [],
      columns: [
        {
          field: "city_name",
          label: "Nama Kota/Lokasi",
        },
        {
          field: "address",
          label: "Alamat",
        },
        {
          field: "phone",
          label: "Nomor Telpon",
        },
        {
          field: "action",
          label: "Aksi",
        },
      ],
      /* Pagination — proxy ke listParams.page (computed get/set di bawah) */
      /* Filter search — proxy ke listParams.search */
      /* Toggle Dialog */
      formDialog: false,
      successNotification: false,
      deleteConfirmModal: false,
      /* Form Value */
      city_name: "",
      address: "",
      phone: "",
      /* Extra Data */
      /* Debounce timer untuk filter search */
      searchDebounceTimer: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.searchDebounceTimer);
  },
  computed: {
    /* Proxy ke reactive listParams agar template/method lama tetap kompatibel.
       Set value akan trigger useQuery refetch otomatis (queryKey berubah). */
    page: {
      get() { return this.listParams.page; },
      set(v) { this.listParams.page = v; },
    },
    limit: {
      get() { return this.listParams.limit; },
      set(v) { this.listParams.limit = v; },
    },
    search: {
      get() { return this.listParams.search; },
      set(v) { this.listParams.search = v; },
    },
    /* Data hasil useBranchAdminList — query auto-refetch saat params berubah */
    data() {
      return this.branchListData || [];
    },
    loading() {
      /* Tampilkan loading hanya saat fetch pertama (belum ada data sama sekali) */
      return this.branchListLoading && !this.branchListData;
    },
    tableLoading() { return this.branchListIsFetching; },
  },
  methods: {
    /*
     * Get Data Method — kini wrapper invalidate (manual refresh)
     */
    async getListData(page, limit) {
      if (typeof page === "number") this.listParams.page = page;
      if (typeof limit === "number") this.listParams.limit = limit;
      await this.branchListRefetch();
    },
    /*
     * Pagination Handler Function
     */
    pageNavHandler(type) {
      switch (type) {
        case "previous":
          this.listParams.page -= 1;
          break;
        case "next":
          this.listParams.page += 1;
          break;
      }
    },
    /*
     * Search Function — set listParams.search, query auto-refetch
     */
    tableInputSearchHandler(event) {
      const value = event.target.value;

      if (value === "") {
        this.listParams.search = "";
      } else {
        this.listParams.search = value;
        this.listParams.page = 1;
        /* useQuery auto-refetch karena queryKey berubah */
      }
    },
    /*
     * Debounced search — tunggu 400ms setelah user berhenti mengetik
     * baru fetch data, supaya tidak request tiap keystroke.
     */
    debouncedSearch(value) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        if (value === "") {
          this.listParams.search = "";
        } else {
          this.listParams.search = value;
          this.listParams.page = 1;
          /* useQuery auto-refetch karena queryKey berubah */
        }
      }, 400);
    },
    /*
     * Create Method
     */
    async createBranch() {
      let data = {
        city_name: this.city_name,
        address: this.address,
        phone: this.phone,
      };

      try {
        const response = await http.post(
          `/api/v1/master/branch/create`,
          data,
          { headers: this.headers }
        );
        console.log(response.data);

        /* Set Toggle */
        this.formDialog = false;
        this.successNotification = true;

        /* Set Data Empty */
        this.emptyFormData();

        /* Refresh Data */
        this.getListData(this.page, this.limit);
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * Get by Id & Update Method
     */
    async editBranch(id) {
      try {
        /* Pakai queryClient.fetchQuery — cache 5 menit per id, dedupe global. */
        const response = await this.qc.fetchQuery({
          queryKey: [...keys.master.all, "admin", "branch-detail", id],
          queryFn: () => fetchBranchById(id),
          staleTime: 5 * 60 * 1000,
        });

        /* Set Data Selected */
        this.dataSelected = response.data[0];

        /* Set Toggle */
        this.formDialog = true;

        /* Set Data Form */
        this.city_name = this.dataSelected.city_name;
        this.address = this.dataSelected.address;
        this.phone = this.dataSelected.phone;
      } catch (error) {
        console.log(error);
      }
    },
    async updateBranch() {
      let data = {
        city_name: this.city_name,
        address: this.address,
        phone: this.phone,
      };

      try {
        const response = await http.put(
          `/api/v1/master/branch/update/${this.dataSelected.id}`,
          data,
          { headers: this.headers }
        );
        console.log(response.data);

        /* Set Toggle */
        this.formDialog = false;
        this.successNotification = true;

        /* Set Data Empty */
        this.emptyFormData();

        /* Refresh Data */
        this.getListData(this.page, this.limit);
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * Delete Method
     */
    async deleteBranch() {
      try {
        const response = await http.delete(
          `/api/v1/master/branch/delete/${this.dataSelected.id}`,
          { headers: this.headers }
        );
        console.log(response.data);

        /* Refresh Data */
        this.getListData(this.page, this.limit);
        this.dataSelected = [];

        /* Set Toggle */
        this.deleteConfirmModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    /* Helpers */
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    emptyFormData() {
      this.city_name = "";
      this.address = "";
      this.phone = "";
    },
    handleSubmit() {
      if (this.dataSelected.length === 0) {
        this.createBranch();
      } else {
        this.updateBranch();
      }
    },
  },
};
</script>

<style scoped></style>
